import React from 'react';
import './AboutUs.css'
const AboutUs = () => {
    return (
        <div>
            <section>
            <div className="container">
                
                    <div className="row mt-5">
                            <div className="col">
                                <img className="img-fluid" src="https://i.ibb.co/fG9dt8d/section1.jpg" alt=""  />
                            </div>
                            <div className="col pt-3 section-text">
                            <h3 className="heading-text">About Our Institue</h3>
                               <p>
                               The Let's Dance Company (voted Bangladesh’s Number 1 dance company) and the Let's Dance Professional Training Institute are widely-acknowledged as the country’s most popular and reputed dance organisations.

                                Together with the Let's Dance Scholarship Foundation Trust, they make up the LD brand, which fosters creative excellence in the talented, enthusiastic dancer (or aspiring dancer), raising the standards of dance in Bangladesh and beyond.

                                We work together, towards professional excellence in exploring dance in various forms such as educational, research, artistic and commercial ventures. We constantly strive for efficiency and customer satisfaction.

                                Our talented team of professional dancers and instructors have all been handpicked and personally trained by our founders; and receive ongoing coaching and regular assessments to ensure that that their skills are up-to-date.
                               </p>
                            </div>
                    </div>
            </div>
                
            </section>
            <section>
            <div className="container">
                
                    <div className="row mt-5">
                            
                            <div className="col pt-3 ms-2 section-text">
                               <h3 className="heading-text">About Our Founders</h3>
                               <p>
                               Our Founder and Artistic Directors are widely-recognised as Bangladesh’s leading choreographer, dancer and TV judge and a multiple Guinness Book of World Records winner. Most of them got Doctor in the Performing Arts (Dance), an honorary title, in recognition of his achievements in the dance sector.

                               Our founders are self-taught artist, whom honed their skills mid-career with workshops at different high class schools of dance around the world. Later they developed their own style of dancing, using thier background in native dance and the experience they got from around the world. We work together, towards professional excellence in exploring dance in various forms such as educational, research, artistic and commercial ventures. We constantly strive for efficiency and customer satisfaction. Our talented team of professional dancers and instructors have all been handpicked and personally trained by our founders; and receive ongoing coaching and regular assessments to ensure that that their skills are up-to-date.
                               </p>
                            </div>
                            <div className="col">
                                <img className="img-fluid" src="https://i.ibb.co/bBwwJFn/section2.jpg" alt=""  />
                            </div>
                    </div>
            </div>
                
            </section>
            
        </div>
    );
};

export default AboutUs;